import { forwardRef, type Ref, type SVGProps } from "react";
const IconLayersFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="m3 11.73 11.94 7.39a2.09 2.09 0 0 0 2.22 0l11.94-7.39a2 2 0 0 0-.1-3.4L17 1.76a2.13 2.13 0 0 0-2 0L3 8.33a2 2 0 0 0 0 3.4" />
    <path d="M28.47 15.32 16 23 3.61 15.27A1 1 0 1 0 2.51 17l12.38 7.7a2.09 2.09 0 0 0 2.22 0L29.52 17a1 1 0 0 0 .31-1.41 1 1 0 0 0-1.36-.27" />
    <path d="M28.47 20.8 16 28.51 3.61 20.75a1 1 0 0 0-1.1 1.77l12.38 7.66a2.09 2.09 0 0 0 2.22 0l12.41-7.67a1 1 0 0 0 .31-1.41 1 1 0 0 0-1.36-.3" />
  </svg>
);
const ForwardRef = forwardRef(IconLayersFilledSVG);
ForwardRef.displayName = "IconLayersFilled";
export { ForwardRef as IconLayersFilled };
